import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { ColorType } from "../../../configs/constants/ColorType";
import AppText from "../../Core/AppText/AppText";
import Flex from "../../Layout/Flex";
import { TextSizeType } from "../../../utils/theme.utils";

interface InfoBlockProps extends InfoBlockStylesProps {
	label?: string;
	value?: string | number | boolean;
	color?: ColorType;
	ignoreTranslation?: boolean;
	width?: string;
	link?: string;
	href?: string;
	size?: TextSizeType;
	className?: string;
	linkTarget?: string;
	lineClamp?: number;
}

interface InfoBlockStylesProps {
	width?: string;
}

const InfoBlock: React.FC<InfoBlockProps> = ({
	label,
	value,
	color,
	ignoreTranslation,
	width,
	link,
	href,
	size,
	className,
	linkTarget,
	lineClamp,
}) => {
	const { t } = useTranslation();

	if (typeof value === "boolean") {
		value = value ? "YES" : "NO";
	}

	const renderAppText = (link?: string, href?: string) => {
		if (link) {
			return (
				<Link to={link} target={linkTarget}>
					<AppText
						margin="0.25rem 0"
						weight="bold"
						textDecoration="underline"
						color="actionBlue"
						size={size}
						lineClamp={lineClamp}
					>
						{ignoreTranslation ? value : value && t(value?.toString() as any)}
					</AppText>
				</Link>
			);
		} else if (href) {
			return (
				<a href={href} target={linkTarget}>
					<AppText
						margin="0.25rem 0"
						weight="bold"
						textDecoration="underline"
						color="actionBlue"
						size={size}
						lineClamp={lineClamp}
					>
						{ignoreTranslation ? value : value && t(value?.toString() as any)}
					</AppText>
				</a>
			);
		} else {
			return (
				<AppText
					margin="0.25rem 0"
					weight="regular"
					color={color}
					size={size}
					lineClamp={lineClamp}
				>
					{ignoreTranslation ? value : value && t(value?.toString() as any)}
				</AppText>
			);
		}
	};

	return (
		<InfoBlocStyles width={width} className={className}>
			<Flex direction="column">
				<AppText margin="0 0 0.1rem 0" size="m" weight="bold" color="grayTextDark">
					{label && t(label as any)}
				</AppText>
				{renderAppText(link, href)}
			</Flex>
		</InfoBlocStyles>
	);
};

export default InfoBlock;

export const InfoBlocStyles = styled.div<InfoBlockStylesProps>`
	min-width: ${(props) => (props.width ? props.width : "20%")};
	margin-bottom: 0.75rem;
`;
